import React from 'react'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import { AppDetailIcon } from 'pages/ApplicationDetailsPage/icons/AppDetailIcon'
import s from './styles/StudentFooterNav.module.scss'

const NeighborAvatar = ({ student }) =>
	student?.name ? (
		<InitialAvatar
			name={student.name}
			size={36}
			avatarKey={student.avatarKey}
			avatarSource={student.avatarSource}
			photoUrl={student.photoUrl}
		/>
	) : (
		<span className={s.avatarEmpty} aria-hidden>
			—
		</span>
	)

const StudentFooterNav = ({
	prevStudent = null,
	nextStudent = null,
	onPrev = () => {},
	onNext = () => {},
}) => {
	return (
		<div className={s.footer}>
			<button
				type="button"
				className={s.nav}
				disabled={!prevStudent}
				onClick={onPrev}
			>
				<span className={s.chevron}>
					<AppDetailIcon name="chevron_left" size={18} />
				</span>
				<span className={s.avatar}>
					<NeighborAvatar student={prevStudent} />
				</span>
				<span className={s.copy}>
					<span className={s.label}>Previous</span>
					<span className={s.name}>{prevStudent?.name || '—'}</span>
				</span>
			</button>

			<button
				type="button"
				className={`${s.nav} ${s.navNext}`}
				disabled={!nextStudent}
				onClick={onNext}
			>
				<span className={s.copy}>
					<span className={s.label}>Next</span>
					<span className={s.name}>{nextStudent?.name || '—'}</span>
				</span>
				<span className={s.avatar}>
					<NeighborAvatar student={nextStudent} />
				</span>
				<span className={s.chevron}>
					<AppDetailIcon name="chevron_right" size={18} />
				</span>
			</button>
		</div>
	)
}

export default StudentFooterNav
